// extracted by mini-css-extract-plugin
export default {"heading":"Editor__heading--mldeix","item":"Editor__item--mLtXyy","text":"Editor__text--bfG+kL","checkbox":"Editor__checkbox--Ykcmme","checked":"Editor__checked--N0DsuP"};